// extracted by mini-css-extract-plugin
export default {"projectItem":"Card_projectItem__AtoJu"};